import { CONTACT_DIALOG_MESSAGES, ContactDialogMessages } from "./contact-dialog.messages";
import { CONSENT_STATUS_MESSAGES, ConsentStatusMessages } from "../consent-status.messages";
import { POPOVER_MESSAGES, PopoverMessages } from "../popover.messages";
import { TABLE_COLUMNS_MESSAGES, TableColumnsMessages } from "../tables/columns.messages";

export type ContactsTableMessages = TableColumnsMessages &
  PopoverMessages &
  ContactDialogMessages &
  ConsentStatusMessages & {
    nameColumn: string;
    emailColumn: string;
    phoneColumn: string;
    personTypeColumn: string;
    platformOption: string;
    consentStatusColumn: string;
    activeColumn: string;
    cityColumn: string;
    stateColumn: string;
    activeYes: string;
    activeNo: string;
    optionsColumn: string;
    sortByLabel: string;
    sortDirectionLabel: string;
    sortDirectionAsc: string;
    sortDirectionDesc: string;
    sortByFirstName: string;
    sortByCity: string;
    sortByState: string;
    sortByActive: string;
    sortByConsent: string;
    contactTableTitle: string;
    startConversation: string;
    startConversationSuccess: string;
    startConversationError: string;
    startConversationInactive: string;
  };

export const CONTACTS_TABLE_MESSAGES: ContactsTableMessages = {
  ...TABLE_COLUMNS_MESSAGES,
  nameColumn: "Nome",
  emailColumn: "Email",
  phoneColumn: "Celular",
  platformOption: "Plataforma",
  personTypeColumn: "Tipo de Pessoa",
  consentStatusColumn: "Status do Consentimento",
  activeColumn: "Ativo",
  cityColumn: "Cidade",
  stateColumn: "Estado",
  activeYes: "Sim",
  activeNo: "Não",
  optionsColumn: "Opções",
  sortByLabel: "Ordenar por",
  sortDirectionLabel: "Direção",
  sortDirectionAsc: "Ascendente",
  sortDirectionDesc: "Descendente",
  sortByFirstName: "Nome",
  sortByCity: "Cidade",
  sortByState: "Estado",
  sortByActive: "Ativo",
  sortByConsent: "Consentimento",
  contactTableTitle: "Listagem de Contatos",
  startConversation: "Iniciar conversa",
  startConversationSuccess: "Conversa iniciada com sucesso!",
  startConversationError: "Erro ao iniciar conversa",
  startConversationInactive: "Não é possível iniciar conversa com um contato inativo.",

  ...CONSENT_STATUS_MESSAGES,
  ...CONTACT_DIALOG_MESSAGES,
  ...POPOVER_MESSAGES,
};
